import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsValveComponent } from './simple-icons-valve.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsValveComponent ],
    exports:      [ SimpleIconsValveComponent ],
    bootstrap:    []
})
export class SimpleIconsValveModule {}
